<template>
  <div class="field has-addons mb-0">
    <WrapWithHint v-if="archiveButtonVisible" class="control" :content="archiveHintText">
      <div @click="onEmptyClick">
        <button class="button" :class="archiveButtonClasses" @click="handleArchive">
          <span class="icon">
            <i class="far fa-eye-slash"></i>
          </span>
          <span>Archive</span>
        </button>
      </div>
    </WrapWithHint>

    <slot name="delete" />

    <WrapWithHint class="control" :content="unarchiveHintText">
      <div @click="onEmptyClick">
        <button class="button" :class="unarchiveButtonClasses" @click="handleUnarchive">
          <span>Restore</span>
        </button>
      </div>
    </WrapWithHint>
  </div>
</template>

<script setup>
  import { computed } from "vue";

  import WrapWithHint from "./wrap-with-hint.vue";
  import { useBulkArchiveButtons } from "./lib/use-bulk-actions.js";

  const props = defineProps({
    store: { type: Object, required: true },
    entityLabel: { type: String, required: true }, // "ingredient" | "recipe"
    // Event name dispatched on `document` when the user clicks Archive/Restore
    // with an empty selection. List components listen for this to pulse their
    // checkbox column. Pass null to skip the empty-click nudge.
    hintEventName: { type: String, default: null },
  });

  const emit = defineEmits(["archive", "unarchive"]);

  const {
    count,
    archiveButtonEnabled,
    unarchiveButtonEnabled,
    archiveButtonVisible,
    archiveHintText,
    unarchiveHintText,
    archiveButtonClasses,
    unarchiveButtonClasses,
  } = useBulkArchiveButtons({
    store: computed(() => props.store),
    entityLabel: props.entityLabel,
  });

  function handleArchive() {
    if (count.value === 0 || !archiveButtonEnabled.value) return;
    emit("archive");
  }

  function handleUnarchive() {
    if (count.value === 0 || !unarchiveButtonEnabled.value) return;
    emit("unarchive");
  }

  function onEmptyClick() {
    if (count.value === 0 && props.hintEventName) {
      document.dispatchEvent(new CustomEvent(props.hintEventName));
    }
  }
</script>
